<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <Title class="mt40">基础信息：</Title>
      <el-descriptions title="">
        <el-descriptions-item label="审批编码">{{info.registration.num}}</el-descriptions-item>
        <el-descriptions-item label="提交时间" v-if="info.payPOList.length">{{dayjs(info.payPOList[0].createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
        <el-descriptions-item label="数据提交来源">{{getDataSourceText(info.registration.dataSource)}}</el-descriptions-item>
        <el-descriptions-item label="支付时间" v-if="info.registration.dataSource == 3 && info.payPOList.length">{{dayjs(info.payPOList[0].payTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
        <el-descriptions-item label="申请类型">{{getApplyType(info.registration)}}</el-descriptions-item>
        <!-- <el-descriptions-item label="升级身份">{{info.registration.registrationType==2?'体验班':'研修班'}}</el-descriptions-item> -->
        <el-descriptions-item label="报名费用">{{info.registration.fee}}</el-descriptions-item>
        <el-descriptions-item label="充值赠送金额" >{{info.registration.upgradeGiftAmount}}</el-descriptions-item>
        <el-descriptions-item label="申请原因">{{info.registration.content}}</el-descriptions-item>
        
        
        <!-- <el-descriptions-item label="付款凭证证件" :span="12">
          <el-image style="width: 150px;height:150px;margin-right:6px;" fit="cover" :src="item.payImg" :preview-src-list="[item.payImg]" v-for="item in info.payPOList" :key="item.id"></el-image>
        </el-descriptions-item> -->
        <el-descriptions-item label="附件" :span="12" v-if="info.registration.applyVoucher">
          <el-image style="width: 150px;height:150px;margin-right:6px;" fit="cover" :src="item" :preview-src-list="[item]" v-for="(item,index) in info.registration.applyVoucher.split(',')" :key="index"></el-image>
        </el-descriptions-item>

      </el-descriptions>
      <intent-registration-credit :registration-id="rowId || $route.query.id" />
      <Title class="mt40">付款信息：</Title>
      <el-descriptions title="付款信息" :column="5" v-if="info.payPOList.length">
        <template v-for="(item,index) in info.payPOList">
          <el-descriptions-item label="付款凭证" ><el-image style="width: 50px;height:50px;margin-right:6px;" fit="cover" :src="item.payImg" :preview-src-list="[item.payImg]"></el-image></el-descriptions-item>
          <el-descriptions-item label="收款银行" >{{item.payBank}}</el-descriptions-item>
          <el-descriptions-item label="付款方式" >{{item.payMethod === 1 ? '扫码支付' : item.payMethod === 2 ? '银行转账' : '-'}}</el-descriptions-item>
          <el-descriptions-item label="支付单号" >{{item.payNum}}</el-descriptions-item>
          <el-descriptions-item label="付款金额" >{{item.payMoney}}</el-descriptions-item>
          <el-descriptions-item label="付款日期" >
            {{item.payTime}}
            <!-- <span v-if="info.registration.state == 1" style="color: #1596cd;cursor: pointer;margin-left: 5px;" @click="handleEdit(item)">修改</span> -->
          </el-descriptions-item>
        </template>
      </el-descriptions>

      <Title class="mt40">客户信息：</Title>
      <el-descriptions title="">
        <el-descriptions-item label="客户姓名">{{userInfo.customerPO.name}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{userInfo.customerPO.pho}}</el-descriptions-item>
        <el-descriptions-item label="原身份">{{info.registration.currentLevelName}}</el-descriptions-item>
      </el-descriptions>
      <Title class="mt40">审批状态：</Title>
      <el-descriptions title="">
        <el-descriptions-item label="审批状态">{{getStateSource(info.registration.state)}}</el-descriptions-item>
        <el-descriptions-item label="收款银行" v-if="info.registration.state==1">{{info.registration.lineUpBankType}}</el-descriptions-item>
        <!-- <el-descriptions-item label="付款单号" v-if="info.registration.state==1">{{payNum}}</el-descriptions-item> -->
        <el-descriptions-item label="驳回原因" v-if="info.registration.state==2">{{info.registration.reasonForRejection}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <Edit ref="edit" @created="handleShow" mode="finance"></Edit>
  </div>
</template>

<script>
import userApi from '@/api/sys/user'
import meetingSignUpApi from '@/api/meeting/meetingSignUp'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import clientListApi from '@/api/client/clientList'
import Edit from './edit.vue'
import IntentRegistrationCredit from '@/components/IntentDeposit/RegistrationCredit'
export default {
  components: {
    IntentRegistrationCredit,
    Edit
  },
  props: ['rowId', 'from'],
  data() {
    return {
      radio1: '全部',
      activeType: '0',
      list: [],
      formVisible: false,
      info: {
        registration: {},
        customerPO: {},
        payPOList: []
      },
      userInfo: {
        customerPO: {}
      },
      technicalState: 1,
      shareData: null,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      areaOptions: [],
      statisticsList: [],
      meetingInfo: {
        count: 0,
        signInCount: 0,
        notSignInCount: 0,
        fee: 0
      },
      payNum: '',
      registrationList: [] // 存储customerView接口返回的registrationList数据
    }
  },
  async created() {
    await this.handleShow()
    await this.getCustomerView()
    // this.getUserInfo()
    // this.getMeeting()
    // if (this.rowItem.areaCount) this.changeIdentity()
    // if (this.technicalState) this.getShareData()
  },
  watch: {
    '$route.query.id': function(newVal) {
      if (newVal) {
        this.rowId = newVal
        this.handleShow()
        this.getCustomerView()
      }
    }
  },
  methods: {
    // 获取数据来源文本
    getDataSourceText(dataSource) {
      const sourceMap = {
        1: 'app业务员添加',
        2: '管理员添加', 
        3: 'app客户报名',
        4: '管理员导入'
      }
      return sourceMap[dataSource] || '未知来源'
    },
    getApplyType(row) {
      if (!row) return '-'
      if (row.registrationType === 1) return '普通人员升级研修班'
      if (row.registrationType === 2) return '普通人员升级体验班'
      if (row.registrationType === 3) return '体验班升级研修班'
      //10|体降普，20|研降普
      if (row.registrationType === 10) return '体验班降级为普通人员'
      if (row.registrationType === 20) return '研修班降级为普通人员'
      if (row.registrationType === 30) return '研修班降级为体验班'
      return '-'
    },
    //获取状态
    getStateSource(row) {
console.log('详情状态',row)
      if (!row) return '-'
      if (row === -1) return '待初审'
      if (row === 0) return '待终审'
      if (row === 1) return '审核通过'
      if (row === 2) return '驳回'
      return '-'
    },
    // 获取充值赠送金额
    getUpgradeGiftAmount() {
      if (!this.registrationList || !this.registrationList.length) {
        return null
      }
      // 根据当前rowId在registrationList中查找对应的upgradeGiftAmount
      const matchedItem = this.registrationList.find(item => item.id == this.rowId)
      return matchedItem ? matchedItem.upgradeGiftAmount : null
    },
    // 获取customerView数据
    async getCustomerView() {
      try {
        // 使用rowId或route.query.id
        const id = this.rowId || this.$route.query.id
        if (!id) {
          return
        }
        // 检查customerRegistrationApi.customerView是否存在
        if (typeof customerRegistrationApi.customerView !== 'function') {
          console.warn('customerView方法不存在')
          return
        }
        const { data } = await customerRegistrationApi.customerView({ id: id })
        if (data && data.registrationList) {
          this.registrationList = data.registrationList
        }
      } catch (error) {
        console.error('获取customerView数据失败:', error)
      }
    },
    handleEdit(item) {
      this.$refs.edit.handleCreate(item)
    },
    async getMeeting() {
      const { data } = await meetingSignUpApi.getCountFeeByUserInfo({ userInfoId: this.rowId })
      if (data) {
        for (let key in this.meetingInfo) {
          if (this.meetingInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
            if (data[key]) {
              this.meetingInfo[key] = data[key]
            }
          }
        }
      }
      // console.log('会议数据data: ',data);
    },
    getUserInfo() {
      // console.log('this.info22222: ',this.info);
      clientListApi.fetchByIdDetail({ customerId: this.info.registration.customerId }).then((data) => {
        this.userInfo = data.data;
        console.log('this.用户: ', this.userInfo);
      })
    },
    handleShow() {
      const id = this.rowId || this.$route.query.id
      if (!id) return
      customerRegistrationApi.getDetail(id)
        .then((data) => {
          this.info = data.data;
          if (this.info.registration.state == 1) {
            this.payNum = this.info.payPOList.map(item => (item.payNum)).join(',')
          }
          this.getUserInfo()
          console.log('this.form:111 ', this.info);
        })
    },
    showArea() {
      this.formVisible = true
    },
    // 获取地区
    changeIdentity() {
      technicianAreaApi.fetchTreeList({
        technicianInfoId: this.rowItem.id,
        isGetAuth: true
      }).then(({
        data
      }) => {
        this.areaOptions = data
      })
    },
    // 切换
    handleCheck() {
      if (this.activeType == 1) {
        this.statisticsList = [{
          label: '普通客户',
          key: '8',
          unit: '人',
          value: 0
        },
        {
          label: '体验班',
          key: '7',
          unit: '人',
          value: 0
        },
        {
          label: '研修班',
          key: '6',
          unit: '人',
          value: 0
        },
        ]
        // this.getClientNum()
      }
      if (this.activeType == 2) {
        this.statisticsList = [{
          label: '营销经理',
          key: '',
          unit: '人',
          value: 0
        },
        {
          label: '大区经理',
          key: '10',
          unit: '人',
          value: 0
        },
        {
          label: '地区经理',
          key: '20',
          unit: '人',
          value: 0
        },
        {
          label: '县区经理',
          key: '30',
          unit: '人',
          value: 0
        }
        ]
        // this.getServiceNum()
      }
      if (this.activeType == 3) {
        this.statisticsList = [{
          label: '总业绩',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '直属客户业绩',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '团队业绩',
          key: '',
          unit: '元',
          value: 0
        }
        ]
        // this.getChildNum()
      }
      if (this.activeType == 4) {
        this.statisticsList = [{
          label: '累计佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '预计佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '已提现佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '可提现佣金',
          key: '',
          unit: '元',
          value: 0
        }
        ]
      }
    },
    // 获取预约服务数量
    async getServiceNum() {
      const {
        data
      } = await technicianServiceOrderApi.getStatusCount({
        technicianInfoId: this.rowItem.id
      })
      // console.log('服务数量: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
          this.statisticsList[0].value = data.reduce((total, current) => {
            return total + current.count
          }, 0)
        })
        console.log('this.statisticsList: ', this.statisticsList);
      }
    },
    // 获取客户数量
    async getClientNum() {
      const {
        data
      } = await clientListApi.getCountByLevelGroup({
        technicianId: this.info.id
      })
      // console.log('客户数量data: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
        })
        // console.log('this.statisticsList: ',this.statisticsList);
      }
    },
    // 获取团队数量
    async getChildNum() {
      const {
        data
      } = await technicianInfoApi.getChildCount(this.info.id)
      // console.log('data: ',data);
      this.statisticsList[0].value = data
    },
    handleBack() {
      const from = this.$route.query.from
      // 如果有rowId说明是从index.vue的列表进入，返回到列表
      if (this.rowId&&from&&from === 'customerIdentityChangeAudit') {
        this.$router.push('/finance/customerIdentityChangeAudit')
       
      } else {
        this.$emit('handleShow', '', 1)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.sex-box {
  border-radius: 50%;
  border: 1px solid;
  width: 16px;
  height: 16px;
  margin: 0 4px;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.grid-content {
  background: #60b7dc33;
  padding: 20px 30px 30px;
  border-radius: 20px;
  font-size: 20px;
  width: 350px;
  height: 153px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
